export const shouldUseLowFareCalendar = (lowFareCalendarOverride, lowFareCalendar) =>
  lowFareCalendarOverride || lowFareCalendar;
